<template>
  <iframe v-if="youTubeId" class="youtube" :style="dimensions" :src="`https://www.youtube.com/embed/${youTubeId}?rel=0`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  <iframe v-else-if="hostedVideoUrl" class="youtube" :style="dimensions" :src="hostedVideoUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</template>

<script>
const defaultAspectRatio = 0.5625 // 1080/1920
export default {
  name: "MediaItem",
  props: {
    youTubeId: String,
    hostedVideoUrl: String,
    aspectRatio: Number
  },
  data: () => {
    return {
      height: 1,
    }
  },
  computed: {
    dimensions () {
      return {
        height: `${this.height}px`,
      }
    }
  },
  mounted () {
    this.resizeStream()
    this.resizeHandler = window.addEventListener("resize", this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.handleResize)
    this.resizeHandler = null

  },
  methods: {
    resizeStream() {
      this.height = this.$el.clientWidth * (this.aspectRatio || defaultAspectRatio)
    },
    handleResize () {
      this.resizeStream()
    }
  }
}
</script>
